import { render, staticRenderFns } from "./AdminPermissionModal.vue?vue&type=template&id=2753ab3e&"
import script from "./AdminPermissionModal.vue?vue&type=script&lang=js&"
export * from "./AdminPermissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports